import { ActionTypes, Paths } from "@/constants"
import store from "@/redux/store"
import { useEffect } from "react"
import { Navigate, Outlet } from "react-router-dom"
import { useAuthContext } from "../components/auth"

export const RequireAuth: React.FC = () => {
  const auth = useAuthContext()

  // @TODO temporarily bypass auth
  if (!auth.isAuthenticated) {
    return <Navigate to={Paths.PUBLIC.LOGIN.PATH} />
  }

  useEffect(() => {
    if (auth.userInfo) {
      const userInfo = JSON.parse(auth.userInfo)
      store.dispatch({
        type: ActionTypes.GET_USER_PROFILE_SUCCESS,
        payload: {
          ...userInfo,
        },
      })
    }
  }, [auth.userInfo])

  return <Outlet />
}
